import gql from 'graphql-tag';
import FieldsBuilding from "graphql/fields/FieldsBuilding";
import HelperGraphql from "utils/helper-graphql";
import FieldsFloor from "graphql/fields/FieldsFloor";
import FieldsTimeslot from 'graphql/fields/FieldsTimeslot'
import FieldsBuildingContact from 'graphql/fields/FieldsBuildingContact'

const fields = {
	'guid': 'String!',
};

export default gql(`
	query building( ${ HelperGraphql.createFields( fields ) } ) {
		building( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsBuilding}
			
			floors {
				${FieldsFloor}
			}
			
			timeslots {
				timeslot {
					${FieldsTimeslot}
				}
			}
			
		    available_for_teams {
	            team {
	                guid
	                name
	            }
	        }
			
		    available_for_employees {
	            employee {
	                guid
	                name
					department{
						name
					}
					team{
						name
					}
	            }
	        }
	        
	        contacts {
	            ${FieldsBuildingContact}
	            
	            language {
	                guid
	            }
	        }
		}
	}
`);

